import { render, staticRenderFns } from "./SpotlightHole.vue?vue&type=template&id=7c1cf17a&"
import script from "./SpotlightHole.vue?vue&type=script&lang=js&"
export * from "./SpotlightHole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports